import * as React from 'react';

export const BlogContext = React.createContext<{
  path: string;
}>({ path: 'unknown' });
